/**
 * The DOM tree an element renders in: the widget's open `ShadowRoot` in web-component mode, else
 * `document`. Use instead of `document.querySelector()` for elements the widget renders itself —
 * inside a shadow tree those are unreachable from `document`.
 */
export function getDomRoot(element: Element | null | undefined): Document | ShadowRoot {
  const root = element?.getRootNode();
  return typeof ShadowRoot !== 'undefined' && root instanceof ShadowRoot ? root : document;
}
